import styled, { css } from 'styled-components';
import { OInlineMessageStatus } from './OInlineMessage.types';
import { baseVariables } from '../../styles';

const { color } = baseVariables;

interface WrapperProps {
  $status: OInlineMessageStatus;
}

const STATUS_COLORS: Record<OInlineMessageStatus, { border: string; bg?: string; fg?: string }> = {
  Information: { border: color.neutral30 },
  Success: { border: color.alert30 },
  Warning: { border: color.alert40 },
  ErrorSev1: { border: color.alert50 },
  ErrorSev2: { border: color.alert50, bg: '#FCEBED' },
  Emergency: { border: color.alert50, bg: color.alert50, fg: color.base20 },
};

const ICON_COLORS: Record<OInlineMessageStatus, string> = {
  Information: color.base10,
  Success: color.alert30,
  Warning: color.alert40,
  ErrorSev1: color.alert50,
  ErrorSev2: color.alert50,
  Emergency: color.base20,
};

const getStatusStyles = (status: OInlineMessageStatus) => {
  const { border, bg, fg } = STATUS_COLORS[status] ?? STATUS_COLORS.Information;

  return css`
    border: 1px solid ${border};
    ${bg && `background-color: ${bg};`}
    ${fg &&
    `color: ${fg};
      * { color: inherit !important; }
    `}
  `;
};

export const getIconColor = (status: OInlineMessageStatus): string => ICON_COLORS[status] ?? ICON_COLORS.Information;

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 1rem;
  border-radius: var(--t-cards-border-radius, 14px);
  overflow: clip;
  gap: 0.5rem;
  ${({ $status }) => getStatusStyles($status)}
`;

export const IconWrapper = styled.div`
  margin-block-start: 0.125rem; /* Margin top to align the icon with the text */
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  min-width: 0;
  gap: 0.25rem;

  [data-component-name='a-web-ui-kit-ABody'] {
    padding-block-end: 0;
  }

  .m-link-tertiary-button,
  .m-link-tertiary-button-external {
    padding-inline: 0;
    width: fit-content;
  }
`;
